import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';
import type { ReportActiveMode } from '../../../../../../shared/types/roi-hub/TableModeSwitcher.types';

export const getTableModeSwitcherStyles = (activeMode: ReportActiveMode, iconPath: string, disabled: boolean) => {
  return {
    container: css`
      display: flex;
      gap: ${theme.spacing(1)};
      align-items: center;
    `,

    label: css`
      margin-right: ${theme.spacing(1)};
    `,

    buttons: css`
      display: flex;
      align-items: center;
      opacity: ${disabled ? 0.5 : 1};
    `,

    button: css`
      &.MuiIconButton-root {
        background-color: ${theme.palette.common.white};
        border: 1px solid ${theme.colors.gray[200]};
        color: ${theme.colors.text[700]};
        padding: 6px ${theme.spacing(1)};

        & .MuiButton-startIcon {
          margin: 0
        },
      },
    `,

    treeButton: css`
      &.MuiIconButton-root {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-color: ${activeMode === 'tree' ? theme.colors.primary.main : theme.colors.gray[200]};
      }
    `,

    treeIcon: css`
      width: 20px;
      height: 20px;
      mask: url(${iconPath}) no-repeat center;
      mask-size: 100%;
      background-color: ${activeMode === 'tree' ? theme.colors.primary.main : theme.colors.text[700]};
    `,

    listButton: css`
      &.MuiIconButton-root {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-color: ${activeMode === 'flat' ? theme.colors.primary.main : theme.colors.gray[200]};
        color: ${activeMode === 'flat' ? theme.colors.primary.main : theme.colors.text[700]};
      }
    `,
  };
};
